import { Root } from './Root'
import { Header } from './Header'
import { Footer } from './Footer'
import { Content } from './Content'
import { Title } from './Title'
import { Body } from './Body'

export const Card = {
  Root,
  Header,
  Footer,
  Content,
  Title,
  Body
}
